module.exports = __webpack_public_path__ + "static/media/yuandanCore3.ed551e85.png";